import { render, staticRenderFns } from "./ALFReviewRequest.vue?vue&type=template&id=27da910c"
import script from "./ALFReviewRequest.vue?vue&type=script&lang=js"
export * from "./ALFReviewRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports